import { render, staticRenderFns } from "./BordersSlider.vue?vue&type=template&id=644e995c&"
import script from "./BordersSlider.vue?vue&type=script&lang=js&"
export * from "./BordersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports